// ReportsPageGlossary.tsx
import { Box, Typography } from '@mui/material';

// Edit glossary entries here, they will be displayed in the order they are listed
const glossaryEntries = [
  {
    term: 'Acknowledged',
    definition:
      'The state when a customer has seen and responded to a new ticket.'
  },
  {
    term: 'Alert',
    definition: 'An event that may have indicators of compromise.'
  },
  {
    term: 'Case',
    definition:
      'Investigation records visible in Scope that capture the analysis and outcome of potential security threats. Cases may be investigated by Kanati, SOC analysts, or both, and may conclude with or without escalation to a ticket.'
  },
  {
    term: 'Escalation',
    definition:
      'A step where a case results in a ticket requiring customer engagement and further action.'
  },
  {
    term: 'Event',
    definition:
      'An action that takes place on a system or network. Events come in two categories, Log and Network'
  },
  {
    term: 'Log Events',
    definition:
      'Events generated by various system logs that are forwarded to Pondurance for processing.'
  },
  {
    term: 'Network Events',
    definition:
      'Events generated through network activity that are forwarded to Pondurance for processing.'
  },
  {
    term: 'Low Forwarder',
    definition:
      'An application that accepts logs from other sources and forwards them to Pondurance.'
  },
  {
    term: 'Remediated',
    definition:
      'Indicates that corrective action has been taken to address the issue described in the ticket (e.g., isolating a host, resetting credentials). The ticket is considered addressed but may remain open for further review or closure.'
  },
  {
    term: 'Recommendations',
    definition:
      "Actionable guidance based on our SOC's monitoring of your environment. Our experts assess your security posture and identify areas for improvement. If no recommendations are provided, it means we haven't observed significant activity prompting suggestions for specific changes. Rest assured, we continue to monitor and assess potential threats to offer valuable insights for your ongoing security efforts."
  },
  {
    term: 'Sensor',
    definition:
      'An application (often on hardware supplied by Pondurance) that collects network events then forwards them to Pondurance.'
  },
  {
    term: 'Service Ticket',
    definition:
      'A request or communication between the MDR customer and Pondurance that is not tied to a specific threat. Service tickets may include questions, configuration changes, scope updates, or other operational needs. They support ongoing collaboration and help ensure clarity and responsiveness in service delivery.'
  },
  {
    term: 'Sidecar',
    definition:
      'A lightweight log collector utility used to assist in retrieving various log types from Windows and Linux endpoints.'
  },
  {
    term: 'Threat Ticket',
    definition:
      'A record created in response to a detected security event or alert. Threat tickets represent potential malicious activity and typically include investigative notes, severity level, impacted assets, and recommended or completed response actions. These tickets help track the lifecycle of a threat from detection through resolution.'
  },
  {
    term: 'P1',
    definition:
      'Confirmed malicious activity of an advanced nature that poses a direct risk to the organization.'
  },
  {
    term: 'P2',
    definition:
      'Suspected malicious activity of an advanced nature that potentially poses high risk to the organization.'
  },
  {
    term: 'P3',
    definition:
      'Security situations with limited risk to the organization and could potentially disrupt user experience and/or introduce indirect risk to the organization.'
  },
  {
    term: 'P4',
    definition:
      'Security policy violations, scams, and/or end user risk but no risk to the organization itself.'
  },
  {
    term: 'P5',
    definition: 'Potential IT operations impact.'
  }
];

const GlossaryItem = ({
  term,
  definition
}: {
  term: string;
  definition: string;
}) => (
  <Typography sx={{ mb: 1.5, fontSize: '12px' }}>
    <strong>{term}:</strong> {definition}
  </Typography>
);

const ReportsPageGlossary = () => {
  return (
    <Box>
      {glossaryEntries.map((entry) => (
        <GlossaryItem
          key={entry.term}
          term={entry.term}
          definition={entry.definition}
        />
      ))}
    </Box>
  );
};

export default ReportsPageGlossary;
